import React from 'react';
import '../css/Modal.css';

class Modal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            piece: [],
        };
        this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event){
        if (event.key === "Escape") {
          this.setState({show: false})
        }
    }
    componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false)
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false)
    }

    // async fetchData() {
    //     //console.log(this.props.qparms)
    //     const axios = require('axios');

    //     //const response = await axios.get('https://tota-rarity-data.teamtota.workers.dev/api/listreduce?Background=Deep%20Blue&Shirt=Hip%20Hop');
    //     const response = await axios.get('https://tota-rarity-data.teamtota.workers.dev/api/list/0');
    //     console.log(response.data)
    //     //this.state.pieces = response
    //     //const response = PIECES;
    //     this.setState({
    //         idLoaded: true,
    //         pieces: response.data
    //     });
    // };


    render() {
        if(!this.props.show){
            return null;
        }
        // const hasSkull = true
        // if (this.props.piece.skull == '') { hasSkull = false }

        return (
            <div className="modal" onClick={this.props.toggle}>
                <div className="model-dialogue">
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className="close-m"><span className="closespan" onClick={this.props.toggle}><img src="close.jpg" width="30" height="30" alt="close modal" /></span></div>
                        <div className="modalleft">    
                            <div className="rarityrank kfont">#{this.props.piece.token}</div>
                            <div><img className="modalimg" src={'/tokens/'+this.props.piece.token+'.jpg'} alt={"Token " + this.props.piece.token}  /></div>
                            <div className="pieceid kfont">T.O.T.A #{this.props.piece.token}</div>
                        </div>
                        <div className="modalright">        
                            <div className="close-d"><span className="closespan" onClick={this.props.toggle}><img src="close.jpg" width="30" height="30" alt="close modal" /></span></div>
                            <div className="modalrighttraits">
                                <div>
                                    {this.props.piece.background !== '' && 
                                        <div className="traitrow">Background
                                            <span className="traitval">{this.props.piece.background}</span>
                                        </div>
                                    }
                                    {this.props.piece.backgear !=='' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Back Gear
                                                <span className="traitval">{this.props.piece.backgear}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.shirt !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Shirt
                                                <span className="traitval">{this.props.piece.shirt}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.skins !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Skins
                                                <span className="traitval">{this.props.piece.skins}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.pants !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Pants
                                                <span className="traitval">{this.props.piece.pants}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.tools !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Tools
                                                <span className="traitval">{this.props.piece.tools}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.jewelry !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Jewelry
                                                <span className="traitval">{this.props.piece.jewelry}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.accessories !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Accessories
                                                <span className="traitval">{this.props.piece.accessories}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.mouth !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Mouth
                                                <span className="traitval">{this.props.piece.mouth}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.eyes !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Eyes
                                                <span className="traitval">{this.props.piece.eyes}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.headgear !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Head Gear
                                                <span className="traitval">{this.props.piece.headgear}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.tribe !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Tribe
                                                <span className="traitval">{this.props.piece.tribe}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.vest !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Vest
                                                <span className="traitval">{this.props.piece.vest}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.arm !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Arm
                                                <span className="traitval">{this.props.piece.arm}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.skull !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Skull
                                                <span className="traitval">{this.props.piece.skull}</span>
                                            </div>
                                        </div>
                                    }
                                    {this.props.piece.special !== '' && 
                                        <div>
                                            <div><hr /></div>
                                            <div className="traitrow">Special
                                                <span className="traitval">{this.props.piece.special}</span>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        );
    }
}
export default Modal